import { Badge, Flex, Text } from '@mantine/core'
import classes from './bales-list.module.css'

export const MAX_BALES_TO_DISPLAY = 1000

export interface BalesListProps {
  baleNumbers: number[]
  duplicates?: number[]
}

export function BalesList({ baleNumbers, duplicates = [] }: BalesListProps) {
  if (baleNumbers.length > MAX_BALES_TO_DISPLAY) {
    return (
      <Text c='red' fw={600} size='xs'>
        Too many bales to display
      </Text>
    )
  }

  return (
    <Flex wrap='wrap' gap='xs'>
      {baleNumbers.map((value, index) => {
        const isDuplicate = duplicates.includes(value)
        return (
          <Badge
            classNames={{
              root: classes.baleBadge,
            }}
            color={isDuplicate ? 'red' : 'black'}
            variant='light'
            fw={600}
            key={`bale-pill-${value}-${index}`}
            aria-label={isDuplicate ? `${value} (duplicate bale number)` : `${value}`}
          >
            {value}
          </Badge>
        )
      })}
    </Flex>
  )
}
